import {
    Button,
} from "@material-ui/core";
import { useState } from "react";
import { BulkEditAssetPopupDialog } from "./BulkEditAssetPopupDialog";
import { BulkEditAssetPopupStyle } from "./BulkEditAssetPopupStyle";
import ReorderIcon from '@mui/icons-material/Reorder';

export const BulkEditAssetPopup = ({
    selectedRows,
    reloadAssets,
    readonly = false,
}) => {

    const classes = BulkEditAssetPopupStyle();
    const [open, setOpen] = useState(false);

    const onOpen = () => {
        setOpen(true);
    }

    return (
        <>
            <Button onClick={!readonly && onOpen} disabled={readonly} className={classes.button}>
                <div>
                    <div>
                        <ReorderIcon className="icon" style={{ color: "#0090fe" }}/>
                    </div>
                    <div>
                        {`Bulk Edit`}
                    </div>
                </div>
            </Button>
            {open && <BulkEditAssetPopupDialog
                setOpen={setOpen}
                open={open}
                selectedRows={selectedRows}
                reloadAssets={reloadAssets}
            />}
        </>
    );
}